import { createGlobalStyle } from "styled-components";
import fontFiles from "./fonts";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Grenette';
    src: url(${fontFiles.GrenetteBoldItalicEOT});
    src: url(${fontFiles.GrenetteBoldItalicEOT}) format('embedded-opentype'),
        url(${fontFiles.GrenetteBoldItalicTTF}) format('truetype'),
        url(${fontFiles.GrenetteBoldItalicWOFF}) format('woff'),
        url(${fontFiles.GrenetteBoldItalicWOFF2}) format('woff2');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Grenette';
    src: url(${fontFiles.GrenetteBoldEOT});
    src: url(${fontFiles.GrenetteBoldEOT}) format('embedded-opentype'),
        url(${fontFiles.GrenetteBoldTTF}) format('truetype'),
        url(${fontFiles.GrenetteBoldWOFF}) format('woff'),
        url(${fontFiles.GrenetteBoldWOFF2}) format('woff2');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Grenette';
    src: url(${fontFiles.GrenetteItalicEOT});
    src: url(${fontFiles.GrenetteItalicEOT}) format('embedded-opentype'),
        url(${fontFiles.GrenetteItalicTTF}) format('truetype'),
        url(${fontFiles.GrenetteItalicWOFF}) format('woff'),
        url(${fontFiles.GrenetteItalicWOFF2}) format('woff2');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Grenette';
    src: url(${fontFiles.GrenetteRegularEOT});
    src: url(${fontFiles.GrenetteRegularEOT}) format('embedded-opentype'),
        url(${fontFiles.GrenetteRegularWOFF2}) format('woff2'),
        url(${fontFiles.GrenetteRegularWOFF}) format('woff'),
        url(${fontFiles.GrenetteRegularTTF}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "Graphik Web";
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikLightEOT}) format("eot"),
      url(${fontFiles.GraphikLightEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikLightSVG}) format("svg"),
      url(${fontFiles.GraphikLightTTF}) format("truetype"),
      url(${fontFiles.GraphikLightWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight: 300;
    font-style: italic;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikLightItalicEOT}) format("eot"),
      url(${fontFiles.GraphikLightItalicEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikLightItalicSVG}) format("svg"),
      url(${fontFiles.GraphikLightItalicTTF}) format("truetype"),
      url(${fontFiles.GraphikLightItalicWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  400;
    font-style:   normal;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikRegularEOT}) format("eot"),
      url(${fontFiles.GraphikRegularEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikRegularSVG}) format("svg"),
      url(${fontFiles.GraphikRegularTTF}) format("truetype"),
      url(${fontFiles.GraphikRegularWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  400;
    font-style:   italic;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikRegularItalicEOT}) format("eot"),
      url(${fontFiles.GraphikRegularItalicEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikRegularItalicSVG}) format("svg"),
      url(${fontFiles.GraphikRegularItalicTTF}) format("truetype"),
      url(${fontFiles.GraphikRegularItalicWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  500;
    font-style:   normal;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikMediumEOT}) format("eot"),
      url(${fontFiles.GraphikMediumEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikMediumSVG}) format("svg"),
      url(${fontFiles.GraphikMediumTTF}) format("truetype"),
      url(${fontFiles.GraphikMediumWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  500;
    font-style:   italic;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikMediumItalicEOT}) format("eot"),
      url(${fontFiles.GraphikMediumItalicEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikMediumItalicSVG}) format("svg"),
      url(${fontFiles.GraphikMediumItalicTTF}) format("truetype"),
      url(${fontFiles.GraphikMediumItalicWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  600;
    font-style:   normal;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikSemiboldEOT}) format("eot"),
      url(${fontFiles.GraphikSemiboldEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikSemiboldSVG}) format("svg"),
      url(${fontFiles.GraphikSemiboldTTF}) format("truetype"),
      url(${fontFiles.GraphikSemiboldWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  600;
    font-style:   italic;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikSemiboldItalicEOT}) format("eot"),
      url(${fontFiles.GraphikSemiboldItalicEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikSemiboldItalicSVG}) format("svg"),
      url(${fontFiles.GraphikSemiboldItalicTTF}) format("truetype"),
      url(${fontFiles.GraphikSemiboldItalicWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  700;
    font-style:   normal;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikBoldEOT}) format("eot"),
      url(${fontFiles.GraphikBoldEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikBoldSVG}) format("svg"),
      url(${fontFiles.GraphikBoldTTF}) format("truetype"),
      url(${fontFiles.GraphikBoldWOFF}) format("woff");
  }
  @font-face {
    font-family: "Graphik Web";
    font-weight:  700;
    font-style:   italic;
    font-stretch: normal;
    src: local("Graphik Web"),
      url(${fontFiles.GraphikBoldItalicEOT}) format("eot"),
      url(${fontFiles.GraphikBoldItalicEOT}) format("embedded-opentype"),
      url(${fontFiles.GraphikBoldItalicSVG}) format("svg"),
      url(${fontFiles.GraphikBoldItalicTTF}) format("truetype"),
      url(${fontFiles.GraphikBoldItalicWOFF}) format("woff");
  }
  body {
    font-family: "Graphik Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale
  }
 
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
